import graphql from "babel-plugin-relay/macro";
import { useSetAtom } from "jotai";

import { useMutationWithError } from "../../../../../../../utils/hooks/useMutationWithError";
import { isCreatingBookingAtom } from "../../../../../atoms/stores";
import {
  CreateRepeatMultiSlotBookingInput,
  useRepeatMultiSlotBookingMutation,
  useRepeatMultiSlotBookingMutation$data,
} from "./__generated__/useRepeatMultiSlotBookingMutation.graphql";
import {
  extractBookingId,
  useCreateBookingErrorHandlers,
} from "./useRepeatBookingHelpers";

export const useRepeatMultiSlotBooking = () => {
  const [repeatMultiSlotBooking, isRepeating] =
    useMutationWithError<useRepeatMultiSlotBookingMutation>(
      useRepeatMultiSlotBookingFragmentString
    );
  const setIsCreatingBooking = useSetAtom(isCreatingBookingAtom);
  const errorHandlers = useCreateBookingErrorHandlers();

  const handleCreateNewMultiSlotBooking = (
    input: CreateRepeatMultiSlotBookingInput,
    onComplete: (bookingId: string) => void
  ) => {
    setIsCreatingBooking(true);
    repeatMultiSlotBooking({
      variables: { input },
      onCompleted: (res: useRepeatMultiSlotBookingMutation$data) => {
        setIsCreatingBooking(false);
        // useMutationWithError only calls onCompleted when success is true
        const bookingId = extractBookingId(res);
        if (bookingId) {
          onComplete(bookingId);
        }
      },
      ...errorHandlers,
    });
  };

  return [handleCreateNewMultiSlotBooking, isRepeating] as const;
};

export const useRepeatMultiSlotBookingFragmentString = graphql`
  mutation useRepeatMultiSlotBookingMutation(
    $input: CreateRepeatMultiSlotBookingInput!
  ) {
    responsePayload: createRepeatMultiSlotBooking(input: $input) {
      errors {
        field
        code
        message
      }
      success
      startSlot {
        id
      }
      booking {
        id
      }
    }
  }
`;
